"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rules_1 = require("./rules");
var addresses_1 = require("./addresses");
var utility_1 = require("../utility");
var create = function (network) {
    var addresses = network === "mainnet" ? addresses_1.mainnet : addresses_1.testnet;
    var rules = (0, rules_1.createAnchorRules)(addresses);
    var depositStableRuleSet = {
        rule: rules.depositStableRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/deposit-stable",
            canonicalMsg: [
                "Deposit ".concat(matched[4].value, "uusd to ").concat(matched[0].value),
                "Mint ".concat(matched[3].value).concat(matched[5].value),
            ],
            payload: fragment,
        }); },
    };
    var redeemStableRuleSet = {
        rule: rules.redeemStableRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/redeem-stable",
            canonicalMsg: [
                "Withdraw ".concat(matched[8].value, "uusd from ").concat(matched[5].value),
                "Burn ".concat(matched[7].value).concat(matched[9].value),
            ],
            payload: fragment,
        }); },
    };
    var bondLunaRuleSet = {
        rule: rules.bondLunaRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/bond-luna",
            canonicalMsg: ["Mint ".concat(matched[4].value).concat(matched[5].value)],
            payload: fragment,
        }); },
    };
    var unbondLunaRuleSet = {
        rule: rules.unbondLunaRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/unbond-bluna",
            canonicalMsg: [
                "Unbond ".concat(matched[4].value).concat(matched[0].value),
                "Burn ".concat(matched[16].value).concat(matched[0].value),
            ],
            payload: fragment,
        }); },
    };
    var withdrawUnbondedRuleSet = {
        rule: rules.withdrawUnbondedRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/withdraw-unbonded",
            canonicalMsg: [
                "Withdraw ".concat((0, utility_1.attachDenom)(matched[3].value), " from ").concat(matched[0].value),
            ],
            payload: fragment,
        }); },
    };
    var claimRewardRuleSet = {
        rule: rules.claimRewardRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/claim-reward",
            canonicalMsg: [
                "Claim ".concat(matched[3].value, "uusd rewards from ").concat(matched[0].value),
            ],
            payload: fragment,
        }); },
    };
    var depositCollateralRuleSet = {
        rule: rules.depositCollateralRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/deposit-collateral",
            canonicalMsg: [
                "Deposit ".concat(matched[4].value).concat(matched[0].value, " collateral to ").concat(matched[11].value),
            ],
            payload: fragment,
        }); },
    };
    var lockCollateralRuleSet = {
        rule: rules.lockCollateralRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/lock-collateral",
            canonicalMsg: ["Lock ".concat(matched[3].value, " to ").concat(matched[0].value)],
            payload: fragment,
        }); },
    };
    var unlockCollateralRuleSet = {
        rule: rules.unlockCollateralRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/unlock-collateral",
            canonicalMsg: ["Unlock ".concat(matched[3].value, " from ").concat(matched[0].value)],
            payload: fragment,
        }); },
    };
    var withdrawCollateralRuleSet = {
        rule: rules.withdrawCollateralRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/withdraw-collateral",
            canonicalMsg: [
                "Withdraw ".concat(matched[3].value).concat(matched[4].value, " collateral from ").concat(matched[0].value),
            ],
            payload: fragment,
        }); },
    };
    var borrowStableRuleSet = {
        rule: rules.borrowStableRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/borrow-stable",
            canonicalMsg: ["Borrow ".concat(matched[3].value, "uusd from ").concat(matched[0].value)],
            payload: fragment,
        }); },
    };
    var repayStableRuleSet = {
        rule: rules.repayStableRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/repay-stable",
            canonicalMsg: ["Repay ".concat(matched[3].value, "uusd from ").concat(matched[0].value)],
            payload: fragment,
        }); },
    };
    var ustSwapRuleSet = {
        rule: rules.ustSwapRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/UST-swap",
            canonicalMsg: [
                "Swap ".concat(matched[9].value).concat(matched[7].value, " for ").concat(matched[10].value).concat(matched[8].value),
            ],
            payload: fragment,
        }); },
    };
    var stakeLPRuleSet = {
        rule: rules.stakeLPRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/stake-LP",
            canonicalMsg: [
                "Stake ".concat(matched[4].value).concat(matched[0].value, " to ").concat(matched[3].value),
            ],
            payload: fragment,
        }); },
    };
    var unstakeLPRuleSet = {
        rule: rules.unstakeLPRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/unstake-LP",
            canonicalMsg: [
                "Unstake ".concat(matched[3].value).concat(matched[4].value, " from ").concat(matched[0].value),
            ],
            payload: fragment,
        }); },
    };
    var airdropRuleSet = {
        rule: rules.airdropRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/airdrop",
            canonicalMsg: ["Claim ".concat(matched[4].value).concat(matched[5].value)],
            payload: fragment,
        }); },
    };
    var lpStakingRewardRuleSet = {
        rule: rules.lpStakingRewardRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/LP-staking-reward",
            canonicalMsg: [
                "Claim ".concat(matched[3].value).concat(matched[4].value, " rewards from ").concat(matched[0].value),
            ],
            payload: fragment,
        }); },
    };
    var borrowRewardRuleSet = {
        rule: rules.borrowRewardsRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/borrow-reward",
            canonicalMsg: [
                "Claim ".concat(matched[2].value).concat(matched[7].value, " rewards from ").concat(matched[0].value),
            ],
            payload: fragment,
        }); },
    };
    var govStakeRuleSet = {
        rule: rules.govStakeRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/gov-stake",
            canonicalMsg: [
                "Stake ".concat(matched[4].value).concat(matched[0].value, " to ").concat(matched[3].value),
            ],
            payload: fragment,
        }); },
    };
    var govUntakeRuleSet = {
        rule: rules.govUnstakeRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/gov-unstake",
            canonicalMsg: [
                "Unstake ".concat(matched[3].value).concat(matched[4].value, " from ").concat(matched[0].value),
            ],
            payload: fragment,
        }); },
    };
    var createPollRuleSet = {
        rule: rules.createPollRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/create-poll",
            canonicalMsg: ["Create poll with ID:".concat(matched[8].value)],
            payload: fragment,
        }); },
    };
    var castVoteRuleSet = {
        rule: rules.castVoteRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/cast-vote",
            canonicalMsg: [
                "Vote to poll with ID:".concat(matched[2].value, " (").concat(matched[5].value, ")"),
            ],
            payload: fragment,
        }); },
    };
    var bETHmintRule = {
        rule: rules.bETHmintRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/mint-bETH",
            canonicalMsg: ["Mint ".concat(matched[3].value).concat(matched[0].value)],
            payload: fragment,
        }); },
    };
    var bETHburnRule = {
        rule: rules.bETHburnRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/burn-bETH",
            canonicalMsg: ["Burn ".concat(matched[7].value).concat(matched[0].value)],
            payload: fragment,
        }); },
    };
    var submitBidRule = {
        rule: rules.submitBidRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/submit-bid",
            canonicalMsg: [
                "Submit ".concat(matched[3].value, "uusd bid to ").concat(matched[0].value),
            ],
            payload: fragment,
        }); },
    };
    var retractBidRule = {
        rule: rules.retractBidRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/retract-bid",
            canonicalMsg: [
                "Retract ".concat(matched[3].value, "uusd bid from ").concat(matched[0].value),
            ],
            payload: fragment,
        }); },
    };
    var executeBidRule = {
        rule: rules.executeBidRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/execute-bid",
            canonicalMsg: ["Liquidation executed by ".concat(matched[2].value)],
            payload: fragment,
        }); },
    };
    var claimLiquidationRule = {
        rule: rules.claimLiquidationRule,
        transform: function (fragment, matched) { return ({
            msgType: "anchor/claim-liquidations",
            canonicalMsg: [
                "Claim ".concat(matched[3].value).concat(matched[2].value, " from liquidations"),
            ],
            payload: fragment,
        }); },
    };
    return [
        depositStableRuleSet,
        redeemStableRuleSet,
        bondLunaRuleSet,
        unbondLunaRuleSet,
        withdrawUnbondedRuleSet,
        claimRewardRuleSet,
        depositCollateralRuleSet,
        lockCollateralRuleSet,
        unlockCollateralRuleSet,
        withdrawCollateralRuleSet,
        borrowStableRuleSet,
        repayStableRuleSet,
        ustSwapRuleSet,
        stakeLPRuleSet,
        unstakeLPRuleSet,
        airdropRuleSet,
        lpStakingRewardRuleSet,
        borrowRewardRuleSet,
        govStakeRuleSet,
        govUntakeRuleSet,
        createPollRuleSet,
        castVoteRuleSet,
        bETHmintRule,
        bETHburnRule,
        submitBidRule,
        retractBidRule,
        executeBidRule,
        claimLiquidationRule,
    ];
};
exports.default = create;
//# sourceMappingURL=index.js.map